import PropTypes from "prop-types";
export const TNavLink = {
  text: PropTypes.string,
  href: PropTypes.string
};
export const TNavLinks = PropTypes.arrayOf(
  PropTypes.shape({
    ...TNavLink,
    children: PropTypes.arrayOf(PropTypes.shape(TNavLink))
  })
);
